import { FC } from 'react'
import styled, { css } from 'styled-components'
import Button from '@app.components/Button'
import CloseIcon from 'svgIcons/Close'

interface IFChipProps {
  label: string
  onClick?: () => void
  className?: string
}

const Chip: FC<IFChipProps> = ({ label, onClick, children, className }) => {
  return (
    <StyledWrapper color="transparent" onClick={onClick} className={className}>
      <div className="chip-label">{label}</div>
      <CloseIcon className="close-icon" />
      {children}
    </StyledWrapper>
  )
}

export default Chip

const StyledWrapper = styled(Button)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 9px 15px;
    border: 1px solid #d9e9f3;
    background-color: ${theme.background.bg_4};

    .chip-label {
      margin-right: 4px;
      font-size: 12px;
      font-weight: normal;
    }

    .close-icon {
      width: 10px;
      height: 10px;
    }
  `}
`
